export function startOfWeek(date) {
    const d = new Date(date);
    const day = d.getDay(); // 0 Sun - 6 Sat
    const diff = (day === 0 ? -6 : 1) - day; // Monday start
    d.setDate(d.getDate() + diff);
    d.setHours(0, 0, 0, 0);
    return d;
  }
  
  export function addDays(date, n) {
    const d = new Date(date);
    d.setDate(d.getDate() + n);
    return d;
  }
  
  export function iso(date) {
    return date.toISOString();
  }

  export function toISO(date) {
    return date.toISOString();
  }

  export function startOfDayLocal(date) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  }

// Birdie Bus operates in Eastern Time. Display all booking/event times in ET.
export const EVENT_TIME_ZONE = "America/New_York";

export function formatEasternDateTime(value, options = {}) {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString([], {
    weekday: options.weekday || "short",
    month: options.month || "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: EVENT_TIME_ZONE,
    ...(options.year ? { year: options.year } : {}),
    ...(options.timeZoneName ? { timeZoneName: options.timeZoneName } : {}),
  });
}

export function formatEasternDate(value, options = {}) {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString([], {
    weekday: options.weekday,
    year: options.year || "numeric",
    month: options.month || "short",
    day: "numeric",
    timeZone: EVENT_TIME_ZONE,
  });
}

export function formatEasternTime(value, options = {}) {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: EVENT_TIME_ZONE,
    ...(options.timeZoneName ? { timeZoneName: options.timeZoneName } : {}),
  });
}
